export function addRate(amount: number, rate: number): number {
  return roundAmount(amount * (1 + rate));
}

export function subtractRate(amount: number, rate: number): number {
  return roundAmount(amount / (1 + rate));
}

export function roundAmount(amount: number): number {
  return Math.round(amount * 100) / 100;
}
